var render = function render(){var _vm=this,_c=_vm._self._c;return (this.type === 'shop')?_c('button',{staticClass:"tooltip",attrs:{"aria-label":"dodaj u korpu","data-tooltip":"Dodaj u korpu"},on:{"click":_vm.addToCart}},[_c('cart-icon')],1):_c('button',{staticClass:"add",on:{"click":_vm.addToCart}},[_vm._v("DODAJ U KORPU")])
}
var staticRenderFns = []

export { render, staticRenderFns }